<template>
	<CRow class="action-bar">
		<CCol md="9" class="manual-synced-container">
			<slot name="header-info"></slot>
		</CCol>
		<CCol :class="['text-right', containerClass]">
			<span
				v-for="({ to, icon, color, text, disabled, onClick }, index) in items"
				:key="index"
				class="container-button"
			>
				<CButton
					v-if="!to"
					:color="color"
					:disabled="disabled"
					class="button transparent mr-3"
					@click="onClick"
				>
					<FontAwesomeIcon
						v-if="icon"
						:icon="icon"
						class="icon-left"
					/>
					{{ text }}
				</CButton>
				<router-link
					v-else
					:to="to"
					:disabled="disabled"
					class="link-button"
				>
					<CButton
						:color="color"
						:disabled="disabled"
						class="button transparent mr-3"
					>
						<FontAwesomeIcon
							v-if="icon"
							:icon="icon"
							class="icon-left"
						/>
						{{ text }}
					</CButton>
				</router-link>
			</span>
		</CCol>
	</CRow>
</template>

<script>
export default {
	name: 'BaseActionBar',

	props: {
		/**
		 * { Object } to
		 * { Array } icon
		 * { String } color
		 * { String } text
		 */
		items: {
			type: Array,
			default: () => [],
		},
		containerClass: {
			type: String,
			default: null,
		},
	},
};
</script>

<style lang="scss" scoped>
.action-bar {
	margin-bottom: rem(32);

	.container-button:last-of-type button {
		margin-right: 0 !important;
	}
}

.manual-synced-container {
	display: flex;
}
</style>
